require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./she-shines-30-june-2022-gallery.json") })
        }
      }, "path---she-shines-30-june-2022-gallery");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---she-shines-30-june-2022-gallery!./.cache/json/she-shines-30-june-2022-gallery.json
// module id = 1188
// module chunks = 231608221292675